// closing-year-end-messages translations (English catalog).
window.PlummeI18n.register('en', {
  "err.yearClosing.unbalancedCarryforward": "The year cannot close: the result is not fully allocated or the next opening balance is unbalanced. Review the postings.",
  "err.yearClosing.taxProvisionMismatch": "Posted current tax differs from the updated basis. Review the tax provision before closing.",

  "clo.importedArchiveTitle": "Imported annual basis",
  "clo.importedArchiveHelp": "This year is historical data from the previous system. Review the figures in reports. A new closing requires a complete accounting basis. Import does not prove filing.",
  "clo.importedArchiveResult": "Result for {year}: {amount}",

  'cye.notAvailableYet': 'Year-end closing is not available yet.',
  'cye.nuf.saved': 'The NUF review has been saved.',
  'cye.nuf.saveFailed': 'Could not save the NUF review.',
  'cye.nuf.headOfficeName': 'Head office name',
  'cye.nuf.foreignRegistrationId': 'Foreign registration number',
  'cye.nuf.homeCountry': 'Home country (ISO code)',
  'cye.nuf.homeLegalForm': 'Legal form in the home country',
  'cye.nuf.framework': 'Accounting framework',
  'cye.nuf.frameworkNorwegian': 'Norwegian GAAP',
  'cye.nuf.frameworkHomeReconciled': 'Home country rules, reconciled to the Norwegian branch',
  'cye.nuf.taxNexus': 'Norwegian tax position',
  'cye.nuf.taxNexusTaxable': 'Taxable activity in Norway is confirmed',
  'cye.nuf.taxNexusExempt': 'Exemption is professionally confirmed',
  'cye.nuf.taxReturnDuty': 'Tax return in Norway',
  'cye.nuf.annualAccountsDuty': 'Annual accounts for the Norwegian branch',
  'cye.nuf.foreignAccountsAttachment': 'Foreign annual accounts as an attachment',
  'cye.nuf.mustFile': 'Must be filed',
  'cye.nuf.exemptAfterReview': 'Not required to file after professional assessment',
  'cye.nuf.notRequiredAfterReview': 'Not required after professional assessment',
  'cye.nuf.required': 'Required',
  'cye.nuf.homeCurrency': 'Home currency',
  'cye.nuf.presentationCurrency': 'Presentation currency',
  'cye.nuf.allocationMethod': 'Result allocation method',
  'cye.nuf.allocationEvidence': 'Documentation for result allocation',
  'cye.nuf.filingEvidence': 'Documentation for filing obligations',
  'cye.nuf.openingBalance': 'Opening intercompany balance',
  'cye.nuf.transfersFrom': 'Transferred from head office',
  'cye.nuf.transfersTo': 'Transferred to head office',
  'cye.nuf.allocatedResult': 'Allocated branch result',
  'cye.nuf.fxDifference': 'Currency difference',
  'cye.nuf.closingBalance': 'Closing intercompany balance',
  'cye.nuf.branchAccountsPrepared': 'The branch accounts have been prepared',
  'cye.nuf.foreignAccountsPrepared': 'The foreign annual accounts are ready when required',
  'cye.nuf.professionalReviewConfirmed': 'The accounting, tax and filing assessment has been professionally reviewed',
  'cye.nuf.expectedClosing': 'Expected closing intercompany balance: {expected} · difference {difference}',
  'cye.nuf.saving': 'Saving…',
  'cye.nuf.save': 'Save NUF review',
});
